import * as React from 'react'

import { ProductRecommendations } from '@thg-commerce/enterprise-widget-product-recommendations/src/ProductRecommendations'
import { EnterpriseProduct } from '@thg-commerce/enterprise-network/types/enterpriseTypes'

import { WidgetNode } from '../../../post-content'
import { ArticleContext } from '../../components/'

interface ProductRecommendationsRendererProps {
  skus: string[]
  isAmp: boolean
}

export const validateSkus = (props: WidgetNode['props']) => {
  const ArticleCtx = React.useContext(ArticleContext)

  if (!props || !('skus' in props)) return false

  const validSkus = (props.skus || []).filter((sku: string) =>
    ArticleCtx.products.has(sku),
  )
  return validSkus.length > 0
}

export const ProductRecommendationsRenderer = ({
  skus,
}: ProductRecommendationsRendererProps) => {
  if (typeof window === 'undefined') return null

  const ArticleCtx = React.useContext(ArticleContext)
  const products = skus?.map((sku) => ArticleCtx.products.get(sku))

  if (!products || products.length < 1) {
    return null
  }

  const productRecommendationsData = (products.filter(
    (product) => product,
  ) as EnterpriseProduct[]).map((product) => {
    return (
      product && {
        sku: product.sku,
        title: product.title,
        brand: {
          name: product.brand?.name,
        },
        url: product.url,
        image: product.images[0]?.largeProduct || '',
        reviews: {
          averageScore: product.reviews?.averageScore ?? 0,
          total: product.reviews?.total ?? 0,
        },
        price: { price: product.price?.displayValue || '' },
      }
    )
  })

  return (
    <ProductRecommendations
      products={productRecommendationsData}
      itemsPerSlide={[1, 2, 3, 4]}
    />
  )
}
